import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Brand, Country } from "api";
import { useIntl } from "react-intl";

interface CountrySelectorProps {
  activeBrand?: Brand;
  brands: Brand[];
  activeCountry?: Country;
  countries: Country[];
  setActiveBrand: (brand?: Brand) => void;
  setActiveCountry: (country?: Country) => void;
}

export function CountrySelector({
  activeBrand,
  brands,
  activeCountry,
  countries,
  setActiveBrand,
  setActiveCountry,
}: CountrySelectorProps) {
  const intl = useIntl();

  return (
    <>
      {activeBrand && brands?.length > 1 && (
        <FormControl>
          <InputLabel id="brands-select-label">{intl.formatMessage({id: 'app.heading.brand'})}</InputLabel>
          <Select
            sx={{ marginRight: '7px', minWidth: '100px' }}
            size='small'
            labelId="brands-select-label"
            id="brands-select"
            value={activeBrand?.id}
            label="Brand"
            onChange={(event) => {
              setActiveBrand(brands.find(({ id }) => id === event.target.value));
            }}
          >
            {brands.map(({ id }) => (
              <MenuItem value={id} key={id}>{id}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {activeCountry && countries?.length > 1 && (
        <FormControl>
          <InputLabel id="countries-select-label">{intl.formatMessage({id: 'app.heading.country'})}</InputLabel>
          <Select
            sx={{ marginRight: '7px', minWidth: '100px' }}
            size='small'
            labelId="countries-select-label"
            id="countries-select"
            value={activeCountry?.id}
            label="Country"
            onChange={(event) => {
              setActiveCountry(countries.find(({ id }) => id === event.target.value));
            }}
          >
            {countries.map(({ id }) => (
              <MenuItem value={id} key={id}>{id}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  )
}
